// extracted by mini-css-extract-plugin
module.exports = {"dimmer-hidden":"Dimmer_dimmer-hidden__CjC67","dimmer":"Dimmer_dimmer__1g7jX","spin":"Dimmer_spin__310Tx"};